var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
require.ensure([], function(require) {
	data = require("!!C:\\Documents and Settings\\kopperts\\My Documents\\repos\\webpack-development\\node_modules\\example-app\\node_modules\\jade-loader\\index.js?self!C:\\Documents and Settings\\kopperts\\My Documents\\repos\\webpack-development\\node_modules\\example-app\\fake-update.js!C:\\Documents and Settings\\kopperts\\My Documents\\repos\\webpack-development\\node_modules\\example-app\\app\\sources.jade");
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
});